var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "website" }, [
      _c("div", { staticClass: "title" }, [_vm._v("系列网站")]),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.siteList, function (item) {
          return _c(
            "el-link",
            {
              key: item.name,
              attrs: { underline: false, href: item.src, target: "_blank" },
            },
            [_vm._v(_vm._s(item.name))]
          )
        }),
        1
      ),
    ]),
    _c("div", { staticClass: "spe_line" }),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact" }, [
      _c("div", { staticClass: "f_logo" }, [
        _c("img", { attrs: { src: require("@/assets/logo.png"), alt: "" } }),
      ]),
      _c("div", { staticClass: "feedback" }, [
        _vm._v("意见反馈：zhang.yining@kepuchina.org.cn"),
      ]),
      _c("div", { staticClass: "telephone" }, [
        _vm._v("联系电话：010-63581721"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }